import React from "react";
import { Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faEye,
  faPencil,
  faTrash,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "antd";
import { getSportName, getTournamentType } from "../../utils/stringUtil";
import { Tournament } from "../../types/Tournaments";

type Props = {
  tournament: Tournament;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onView?: React.MouseEventHandler<HTMLButtonElement>;
  onEdit?: React.MouseEventHandler<HTMLButtonElement>;
  onDelete?: React.MouseEventHandler<HTMLButtonElement>;
};

const STATUS_CONFIG = (tournament: Tournament) => {
  if (tournament.ended) return { color: "#dc3545", bg: "danger", label: "Terminato" };
  if (new Date() >= new Date(tournament.date)) return { color: "#e67e22", bg: "warning", label: "In corso" };
  return { color: "#198754", bg: "success", label: "Prossimo" };
};

function TournamentItem({ tournament, onEdit, onDelete, onView }: Props) {
  const status = STATUS_CONFIG(tournament);

  return (
    <div
      style={{
        borderRadius: 12,
        overflow: "hidden",
        border: "1px solid #e8e8e8",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        transition: "box-shadow 0.2s",
      }}
    >
      {/* Status accent bar */}
      <div style={{ height: 4, background: status.color }} />

      <div style={{ padding: "16px 16px 12px", flexGrow: 1, display: "flex", flexDirection: "column", gap: 10 }}>
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
          <h6 style={{ margin: 0, fontWeight: 700, fontSize: 14, lineHeight: 1.3, flex: 1 }}>
            {tournament.name}
          </h6>
          <Badge bg={status.bg} style={{ fontSize: 10, whiteSpace: "nowrap" }}>
            {status.label}
          </Badge>
        </div>

        {/* Dates */}
        <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <small className="text-muted" style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <FontAwesomeIcon icon={faCalendarAlt} style={{ width: 12 }} />
            {new Date(tournament.date).toLocaleDateString("it")}
          </small>
          <small className="text-muted" style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <FontAwesomeIcon icon={faClock} style={{ width: 12 }} />
            Iscrizioni: {new Date(tournament.registrationDeadline).toLocaleDateString("it")}
          </small>
        </div>

        {/* Badges */}
        <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
          <Badge bg="primary" style={{ fontSize: 10 }}>
            {getSportName(tournament.sport?.name || "")}
          </Badge>
          <Badge bg="secondary" style={{ fontSize: 10 }}>
            {getTournamentType(tournament.type)}
          </Badge>
          {tournament.fitp && (
            <Badge bg="info" style={{ fontSize: 10 }}>
              FITP
            </Badge>
          )}
        </div>
      </div>

      {/* Action row */}
      <div
        style={{
          display: "flex",
          gap: 6,
          padding: "10px 16px",
          borderTop: "1px solid #f0f0f0",
          justifyContent: "flex-end",
        }}
      >
        <Tooltip title="Vedi Dettagli" mouseEnterDelay={0.3}>
          <button className="circle-button" onClick={onView}>
            <FontAwesomeIcon size="sm" icon={faEye} />
          </button>
        </Tooltip>
        <Tooltip title="Modifica" mouseEnterDelay={0.3}>
          <button className="circle-button" onClick={onEdit}>
            <FontAwesomeIcon size="sm" icon={faPencil} />
          </button>
        </Tooltip>
        <Tooltip title="Elimina" mouseEnterDelay={0.3}>
          <button className="circle-button" onClick={onDelete}>
            <FontAwesomeIcon size="sm" icon={faTrash} />
          </button>
        </Tooltip>
      </div>
    </div>
  );
}

export default TournamentItem;
